export const aboutMeData = [
	{
		id: 1,
		bio: 'My name is Alma Alvarado, a first-generation Latina graduate from California State University, Long Beach. With a strong background in computer science and a drive to create impactful solutions, I am a passionate software engineer dedicated to making a difference.',
	},

	{
		id: 2,
		bio: 'My expertise lies in backend RESTful API development, software architecture, and building scalable web applications. I have hands-on experience in Python, Java, Golang, and JavaScript frameworks like Django and React.js.',
	},
	{
		id: 3,
		bio: 'I stay at the forefront of emerging technologies, committed to continuous learning and growth. In addition to my technical skills, I believe in giving back to my community. I am actively involved in teaching and mentoring young students interested in pursuing STEM-related fields, contributing to their growth and development.',
	},
	{
		id: 4,
		bio: "With a track record of successful projects, such as designing and implementing a new parental control feature for a global gaming platform and collaborating with cross-functional teams to ensure seamless launches, I bring both technical expertise and teamwork to the table."
	},
	{
		id: 5,
		bio: "In my free time, you'll find me immersing myself in creating innovative web applications. I am proud to be a part of organizations like Safe Place for Youth and Mar Vista Family Center, where I serve on their boards to contribute to poverty alleviation and provide educational opportunities to underserved communities.",
	},
	{
		id: 6,
		bio: "Let's connect and explore how we can collaborate to make a meaningful impact together. Whether it's architecting scalable solutions or empowering the next generation of STEM enthusiasts!"
	}
];
